<div class="earn-booking-credits-section">
  <!-- Background Mask -->
  <div class="background-mask">
    <img src="assets/images/first_section_mask.png" alt="Background Mask">
  </div>

  <!-- Content Section -->
  <div class="content">
    <h1>
      <span class="highlight">Earn</span> <br>
      booking credits + cash
    </h1>
    <p class="primary-color">
      For every <strong>transaction</strong>, <strong>recommendation,</strong><br> sign-up <strong>referral</strong>, and <strong>review</strong>!
    </p>
    <a (click)="scrollToTop()" class="btn btn-theme btn-large" target="_blank">
      <span>Book your next stay now</span>
    </a>
  </div>

  <!-- Image Section -->
  <div class="image-container">
    <img src="assets/images/first_section_full_image_group.webp" alt="Full Image Group">
  </div>
</div>
